module.exports = __webpack_public_path__ + "static/img/7f290c49481d5f7d19ad43cd846cb7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片2.png
// module id = ywgp
// module chunks = 1